(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-tabs"] && !Shopify.designMode) return;
  try {
    
  class BlogTabsComponent extends HTMLElement {
    connectedCallback() {
      this._tabs = Array.from(this.querySelectorAll('.blog-tabs__tab'));
      this._panels = Array.from(this.querySelectorAll('.blog-tabs__panel'));
      this._init();
    }

    _init() {
      // Progressive enhancement: hide non-active panels
      this._panels.forEach((panel, i) => {
        if (i !== 0) panel.hidden = true;
      });

      this._tabs.forEach((tab) => {
        tab.addEventListener('click', () => this._selectTab(tab));
        tab.addEventListener('keydown', (e) => this._handleKeydown(e, tab));
      });
    }

    _selectTab(selectedTab) {
      const idx = selectedTab.dataset.tab;

      this._tabs.forEach((t) => {
        t.classList.remove('blog-tabs__tab--active');
        t.setAttribute('aria-selected', 'false');
        t.setAttribute('tabindex', '-1');
      });

      this._panels.forEach((p) => {
        p.hidden = true;
      });

      selectedTab.classList.add('blog-tabs__tab--active');
      selectedTab.setAttribute('aria-selected', 'true');
      selectedTab.setAttribute('tabindex', '0');

      const activePanel = this.querySelector(`.blog-tabs__panel[data-tab="${idx}"]`);
      if (activePanel) activePanel.hidden = false;

      // Update desktop "View all" href to match active tab's tag URL
      const viewAllDesktop = this.querySelector('.blog-tabs__view-all--desktop');
      if (viewAllDesktop && selectedTab.dataset.tagUrl) {
        viewAllDesktop.href = selectedTab.dataset.tagUrl;
      }
    }

    _handleKeydown(e, tab) {
      const currentIdx = this._tabs.indexOf(tab);
      let nextTab = null;

      if (e.key === 'ArrowRight') {
        nextTab = this._tabs[(currentIdx + 1) % this._tabs.length];
      } else if (e.key === 'ArrowLeft') {
        nextTab = this._tabs[(currentIdx - 1 + this._tabs.length) % this._tabs.length];
      } else if (e.key === 'Home') {
        nextTab = this._tabs[0];
      } else if (e.key === 'End') {
        nextTab = this._tabs[this._tabs.length - 1];
      }

      if (nextTab) {
        e.preventDefault();
        nextTab.focus();
        this._selectTab(nextTab);
      }
    }

    // Re-init when Shopify theme editor reloads the section
    onSectionLoad() {
      this._tabs = Array.from(this.querySelectorAll('.blog-tabs__tab'));
      this._panels = Array.from(this.querySelectorAll('.blog-tabs__panel'));
      this._init();
    }
  }

  if (!customElements.get('blog-tabs-component')) {
    customElements.define('blog-tabs-component', BlogTabsComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
